/**
 * helper function for when we have a group of messages to rotate, implements a simple throttle since this function will
 * run on the template (with every render). Due to it incrementing the index, the output subtracts 1 to account for the increase
 * */

export function getCurrentIndex(incr){
    if(!window.msgIdxLock)
    {
        window.msgIdx=((window.msgIdx||0)+(incr||0));
    }
    window.msgIdxLock=true;
    window.setTimeout(()=>{window.msgIdxLock=false},1000)
    return window.msgIdx > 0 ? window.msgIdx -1:0;
}
